import {
  RULE_CATEGORIES_REQUEST,
  RULE_CATEGORIES_FAILURE,
  RULE_CATEGORIES_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
  data: [],
  isFetched: false,
  isFetching: false,
};

export const ruleCategoryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case RULE_CATEGORIES_REQUEST:
      return { ...state, isFetching: true };
    case RULE_CATEGORIES_SUCCESS:
      return { ...state, isFetching: false, isFetched: true, data: preserveArrayReference(state.data, action.data) };
    case RULE_CATEGORIES_FAILURE:
      return { ...state, isFetching: false };
    default:
      return state;
  }
};
